export const WORKER_TYPES = {
    SOUND_WORKER: 'SOUND_WORKER',
};
